"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalServiceTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class ExternalServiceTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(serviceTask, processModel) {
        super(serviceTask, processModel);
        this.topic = serviceTask.topic;
        this.payload = serviceTask.payload;
        this.isSingleTry = serviceTask.isSingleTry;
    }
}
exports.ExternalServiceTaskViewModel = ExternalServiceTaskViewModel;
//# sourceMappingURL=ExternalServiceTaskViewModel.js.map